import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {CockpitCard} from 'shared/dtos/cockpit-card';
import {ChartsM2} from 'shared/dtos/cockpit/charts/charts';
import {FunktionswertGesamtverdienst} from 'shared/dtos/cockpit/charts/funktionswert-gesamtverdienst';
import {CockpitM2} from 'shared/dtos/cockpit/cockpit';
import {PersonenUndStellenbezogeneMerkmaleM2} from 'shared/dtos/cockpit/personen-und-stellenbezogene-merkmale-m2';
import {DataStorageService} from 'shared/services/data-storage.service';
import {TableExportService} from 'shared/services/table-data-export/table-data-export.service';
import {CockpitContentComponent} from '../../cockpit-shared/cockpit-content-component';
import {CurrentLocaleComponent} from 'shared/components/current-locale-component';

@Component({
  selector: 'app-chart-dialog-personen-stellenbezogene-merkmale-m2',
  templateUrl:
    './chart-dialog-personen-stellenbezogene-merkmale-m2.component.html',
  styleUrls: [
    './chart-dialog-personen-stellenbezogene-merkmale-m2.component.scss',
    '../../cockpit-shared/card/card.component.scss'
  ],
  standalone: false
})
export class ChartDialogPersonenStellenbezogeneMerkmaleM2Component
  extends CurrentLocaleComponent
  implements OnInit, CockpitContentComponent
{
  card: CockpitCard;
  chart: Highcharts.Chart;

  personenStellenbezogeneMerkmale: PersonenUndStellenbezogeneMerkmaleM2;
  funktionswertGesamtverdienst: FunktionswertGesamtverdienst;

  constructor(
    protected readonly translate: TranslateService,
    private readonly storage: DataStorageService,
    private readonly tableExport: TableExportService
  ) {
    super(translate);
    this.personenStellenbezogeneMerkmale =
      new PersonenUndStellenbezogeneMerkmaleM2();
  }

  async ngOnInit() {
    super.ngOnInit();
    this.storage.getChartsData().then((data: ChartsM2) => {
      this.funktionswertGesamtverdienst = data.funktionswertGesamtverdienst;
    });

    this.storage.getCockpitData().then(data => {
      this.personenStellenbezogeneMerkmale = (
        data as CockpitM2
      ).personenUndStellenbezogeneMerkmale;
    });
  }

  exportChart() {
    this.chart.exportChart(
      {
        type: 'application/pdf',
        filename: 'my-pdf'
      },
      {}
    );
  }

  exportTable() {
    const cardTitle = this.translate.instant(
      'm1-m2.sprint10.cockpit.card.PersonalStellenbezogeneMerkmale.title'
    );
    this.tableExport.exportHtmlTable(null, cardTitle);
  }
}
